import React from "react";

function Footer() {
  return (
    <div id="footer">
      <p>© 2021 Open Grid LLC. All rights reserved.</p>
    </div>
  );
}

export default Footer;
